<template>
    <div class="w-full">
            <div class="w-full md:w-1/2 mx-auto">
                <div class="w-full h-64 mt-10">
                    <h1 class="text-center font-bold tracking-wider text-2xl md:text-3xl font-viga text-secondary mb-5" >
                        Tahap 1 - Biodata
                    </h1>
                      <!-- Data Pasien -->
                        <PasienCard
                            :pasien="pasien"
                        />
                </div>
                <div class="w-full mt-60 md:mt-52">
                    <!-- Button -->
                    <Link class="btn-primary w-full text-white mt-24" :href="BPJSRegisLink">
                        DAFTAR DENGAN BPJS
                    </Link>

                    <Link class="btn-secondary mt-2 w-full text-white" :href="SelfRegisLink" >
                            DAFTAR BAYAR SENDIRI
                    </Link>
                </div>
            </div>
        </div>
</template>


<script>
import { Link } from '@inertiajs/inertia-vue3'
import LayoutNoHeader from '../../Shared/LayoutNoHeader.vue'
import PasienCard from '../../Shared/PasienCard.vue'
export default{
    props: {
        pasien: Object,
        SelfRegisLink: String,
        BPJSRegisLink: String
    },
    components: {
        Link,
        PasienCard
    },
    layout: LayoutNoHeader
}
</script>